export const setURLState = (state, options) => {
    const { clear = false, replace = true } = options || {};
    const params = clear ? new URLSearchParams() : new URLSearchParams(window.location.search);

    Object.entries(state).forEach(([key, value]) => {
        if (value == null) {
            params.delete(key);
            return;
        }

        if (Array.isArray(value)) {
            params.delete(key);
            value.forEach(v => {
                if (v != null) params.append(key, v);
            });
        } else {
            params.set(key, value);
        }
    });

    const query = params.toString();
    const newUrl = query ? `${window.location.pathname}?${query}` : window.location.pathname;

    const method = replace ? 'replaceState' : 'pushState';
    window.history[method](null, '', newUrl);
};
